import React, { createContext, useContext, useState } from "react"

import native from "../native/native"
import useQueryParams from "../hooks/useQueryParams"

export type FeatureAlert = "security+" | "organization+"
export type FeatureAlertSource = "bubbleFeatureList" | "default"

interface State {
  showComparePlansSheet: boolean
  showFeatureAlert: FeatureAlert | null
  featureAlertSource: FeatureAlertSource
  showBeforeYouGo: boolean
  showBasicTitle: boolean
}

interface Actions {
  setShowComparePlansSheet: (show: boolean) => void
  setShowBeforeYouGo: (show: boolean) => void
  setShowFeatureAlert: (
    featuerAlert: FeatureAlert | null,
    source?: FeatureAlertSource,
  ) => void
  setShowBasicTitle: (show: boolean) => void
}

interface Context {
  state: State
  actions: Actions
}

//TODO: Reame this
const UltimateAlertsContext = createContext<Context | null>(null)

const UltimateAlertsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [showComparePlansSheet, setShowComparePlansSheetState] = useState(false)
  const [showFeatureAlert, setShowFeatureAlertState] =
    useState<FeatureAlert | null>(null)
  const [featureAlertSource, setFeatureAlertSource] =
    useState<FeatureAlertSource>("default")
  const [showBeforeYouGo, setShowBeforeYouGoState] = useState(false)
  const [showBasicTitle, setShowBasicTitle] = useState(false)

  const setShowComparePlansSheet = (show: boolean) => {
    setShowComparePlansSheetState(show)
    if (show) {
      native.logMixpanelEvent("html_compare_plans")
    }
  }

  const setShowFeatureAlert = (
    feature: FeatureAlert | null,
    source: FeatureAlertSource = "default",
  ) => {
    setShowFeatureAlertState(feature)
    setFeatureAlertSource(source)
    if (feature) {
      native.logMixpanelEvent("html_feature_popup", { feature })
    }
  }

  const setShowBeforeYouGo = (show: boolean) => {
    setShowBeforeYouGoState(show)
    if (show) {
      native.logMixpanelEvent("html_before_you_go")
    }
  }

  const state: State = {
    showFeatureAlert,
    featureAlertSource,
    showComparePlansSheet,
    showBeforeYouGo,
    showBasicTitle,
  }

  const actions: Actions = {
    setShowFeatureAlert,
    setShowComparePlansSheet,
    setShowBeforeYouGo,
    setShowBasicTitle,
  }

  return (
    <UltimateAlertsContext.Provider value={{ state, actions }}>
      {children}
    </UltimateAlertsContext.Provider>
  )
}

const useUltimateAlerts = () => {
  const context = useContext(UltimateAlertsContext)

  if (!context) {
    throw new Error(
      "useUltimateAlerts has to be used within <UltimateAlertsContext.Provider>",
    )
  }

  return context
}

export { UltimateAlertsProvider, UltimateAlertsContext, useUltimateAlerts }
